import { takeLatest, fork } from "redux-saga/effects";
import { listFetchSaga, createSaga, updateSaga } from "./base-saga";
import BankAccountActions from "../constants/actions";
import BankAccountService from "../services";


export default fork(function*() {
    yield takeLatest(
        BankAccountActions.BANK_ACCOUNTS.LIST.FETCH,
        listFetchSaga(BankAccountActions.BANK_ACCOUNTS.LIST, BankAccountService.fetchBankAccountsList)
    );
    yield takeLatest(
        BankAccountActions.BANK_ACCOUNTS.ACCOUNT.CREATE,
        createSaga(BankAccountActions.BANK_ACCOUNTS.ACCOUNT, BankAccountService.createNewBankAccounts)
    );
    yield takeLatest(
        BankAccountActions.BANK_ACCOUNTS.ACCOUNT.UPDATE,
        updateSaga(BankAccountActions.BANK_ACCOUNTS.ACCOUNT, BankAccountService.updateExistingBankAccounts)
    );
});